import { Typography, Stack } from "@mui/material";
import { styled, Box } from "@mui/system";
import theme from "../theme";

export const ExpandedContent = styled(Box)`
  padding: 12px 16px;
`;

export const SectionTitle = styled(Typography)`
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.57;
  color: ${theme.palette.text.primary};
  margin-bottom: 0.35em;
`;

export const SectionContent = styled(Typography)`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.43;
  color: ${theme.palette.text.primary};
  margin-bottom: 12px;
`;

export const OrdersList = styled(Stack)`
  gap: 8px;
`;

export const OrderHeaderRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SpecimenInfoContainer = styled(Stack)`
  gap: 4px;
  margin-bottom: 12px;
`;

export const ReportsList = styled(Stack)`
  gap: 8px;
  margin-top: 8px;
`;

export const ReportRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const ReportFileName = styled(Typography)`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.43;
  color: ${theme.palette.text.primary};
`;
